import { mixed, object, string } from 'yup';

import { US_STATE_OPTIONS } from '../../../../../constants';
import { buildRichTextSchema } from '../../../../common';
import { MEDICAL_DELIVERY_OPTIONS, MEDICAL_HEARING_OPTIONS, MEDICAL_HISTORY_MAX_LENGTH, MEDICAL_SEVERITY_OPTIONS, MEDICAL_VISION_OPTIONS } from './constants';

import type { Moment } from 'moment';

function medicalNumberSchema(max = 99) {
  return string().required('Required').matches(/^\d{1,2}$/, 'Enter a whole number with one or two digits')
    .test('range', `Enter a number from 0 to ${max}`, (value) => Number(value) <= max);
}

function medicalDateSchema() {
  return mixed<Moment>().nullable().test('valid-date', 'Enter a valid date', (value) => value == null || value.isValid()).required('Required');
}

export const MEDICAL_FORM_SCHEMA = object({
  allergies: string().trim().min(4).max(255).required('Required'),
  special_diets: string().trim().min(4).max(255).required('Required'),
  hearing_difficulty: string().oneOf(MEDICAL_HEARING_OPTIONS).required('Required'),
  hearing_screening_date: medicalDateSchema(),
  vision_difficulty: string().oneOf(MEDICAL_VISION_OPTIONS).required('Required'),
  vision_screening_date: medicalDateSchema(),
  trauma_history: buildRichTextSchema({ minLength: 4, maxLength: MEDICAL_HISTORY_MAX_LENGTH, minMessage: 'Enter at least 4 characters', maxMessage: 'Enter no more than 50000 characters' }),
  hospitalization_history: buildRichTextSchema({ minLength: 4, maxLength: MEDICAL_HISTORY_MAX_LENGTH, minMessage: 'Enter at least 4 characters', maxMessage: 'Enter no more than 50000 characters' }),
  asd_severity_level: string().oneOf(MEDICAL_SEVERITY_OPTIONS).required('Required'),
  asd_diagnosis_provider_name: string().trim().min(8).max(255).required('Required'),
  asd_diagnosis_city: string().trim().min(2).max(255).required('Required'),
  asd_diagnosis_state: string().oneOf(US_STATE_OPTIONS.map((option) => option.value)).required('Required'),
  asd_diagnosis_year: medicalDateSchema().test('year-range', 'Enter a year from 1900 to 2100', (value) => value.year() >= 1900 && value.year() <= 2100),
  child_delivery_type: string().oneOf(MEDICAL_DELIVERY_OPTIONS).required('Required'),
  child_gestational_age_weeks: medicalNumberSchema(),
  child_weight_at_birth_pounds: medicalNumberSchema(),
  child_weight_at_birth_ounces: medicalNumberSchema(15),
  child_sitting_up_age_months: medicalNumberSchema(),
  child_crawling_age_months: medicalNumberSchema(),
  child_walking_age_years: medicalNumberSchema(),
  child_walking_age_months: medicalNumberSchema(),
  child_standing_age_years: medicalNumberSchema(9),
  child_standing_age_months: medicalNumberSchema(),
  child_babbling_age_months: medicalNumberSchema(),
  child_first_word: string().min(2).max(16).matches(/^\S+$/, 'Enter one word').required('Required'),
  child_second_word: string().min(2).max(16).matches(/^\S+$/, 'Enter one word').required('Required'),
  child_first_words_age_months: medicalNumberSchema(),
});
